<template>
  <v-layout row wrap align-end white pl-4>
    <v-flex xs4 pr-4>
      <v-autocomplete
        ref="condominiumCbo"
        clearable
        v-model="condominium_id"
        :items="condominiumsList"
        item-text="name_fantasy"
        item-value="id"
        label="Condomínio"
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template v-if="checkType(data)">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-autocomplete>
    </v-flex>
    <v-flex xs2 pr-4 v-show="false">
      <v-autocomplete
        clearable
        v-model="status"
        :items="[]"
        item-text="text"
        item-value="id"
        label="Status"
      ></v-autocomplete>
    </v-flex>
    <v-flex xs2 pr-4>
      <v-menu
        v-model="date_limit_menu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            clearable
            v-model="date_limit_formated"
            mask="##/##/####"
            return-masked-value
            label="Data limite"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker no-title v-model="date_limit" @input="date_limit_menu = false"></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs2>
      <v-text-field v-model="year" label="Exercício">
        <template v-slot:append-outer>
          <v-slide-x-reverse-transition mode="out-in">
            <v-icon @click="loadDataForm">search</v-icon>
          </v-slide-x-reverse-transition>
        </template>
      </v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import * as moment from 'moment'
export default {
  computed: {
    date_limit_formated: {
      get () {
        return this.date_limit
          ? moment(this.date_limit).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.date_limit = new Date().toISOString().substr(0, 10)
            return
          }
          this.date_limit = date
        } else {
          this.date_limit = ''
        }
      }
    }
  },
  data () {
    return {
      date_limit: '',
      date_limit_menu: false,
      statuses: [],
      status: '',
      condominium_id: '',
      year: ''
    }
  },
  props: {
    condominiumsList: Array,
    search: Function
  },
  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },
    loadDataForm () {
      let data = {
        condominium_id: this.condominium_id,
        status: this.status,
        year: this.year,
        date_limit: this.date_limit
      }
      this.search(data)
    }
  }
}
</script>

<style>
</style>
